import React from "react";
import { ClipLoader } from "@lua-frontend/numu-ui";
import "./btn.scss";

const Button = (props) => {
  const {
    onClick,
    action = false,
    text = "",
    style = {},
    disabled = false,
    secondary, // without background
    tertiary, // green,
    quaternary, // light blue blackground
    ...other
  } = props;

  return (
    <button
      className={`
        ${action ? "button act-btn" : `button`} 
        ${style?.background || style?.backgroundColor ? "no-background" : ""}
        ${style?.padding ? "no-padding" : ""}
        ${
          secondary
            ? "button-type-bezeled-grey"
            : tertiary
            ? "tertiary-clear-btn"
            : quaternary
            ? "button-type-bezeled"
            : "button-type-filled"
        }`}
      disabled={disabled}
      style={style}
      onClick={onClick}
      {...other}
    >
      {other.isLoading && (
        <div className="loader">
          <ClipLoader size={16} color="var(--grey-30)" />
        </div>
      )}
      {text}
    </button>
  );
};

export { Button };
